import { getMessaging, getToken, onMessage } from "firebase/messaging"
import { messaging } from "../StApp"
import { AppComm } from "../models/api/AppComm"
import { AppCommType } from "../models/api/AppCommType"
import { FCMBase } from "../models/api/FCMBase"
import { OfflineMsgType } from "../models/api/OfflineMsgType"
import { FCM_KEY } from "../models/constants"
import { rootStore } from "../StApp"
import ApiService from "./ApiService"
import AppCommHandlerService from "./AppCommHandlerService"
import LocalStorageService from "./LocalStorageService"
import Logger from "./Logger"

class FCMService {

    generateToken() {

        if (rootStore.mainStore.fcmToken)
            return

        getToken(messaging, { vapidKey: FCM_KEY }).then(currToken => {
            if (currToken) {
                this.updateFcmToken(currToken)
                Logger.info(currToken, 'FCM Token')
                ApiService.updateFcmToken({ uid: rootStore.mainStore.uid!, fcmToken: currToken })
                    .then(resp => Logger.info(resp.data))
            }

        }).catch(err => Logger.err(err))

    }

    registerListeners() {

        onMessage(messaging, (payload) => {
            Logger.info(payload, 'FCM_MSG')
            const fcmBase = payload.data as unknown as FCMBase
            if(fcmBase.type == 'APP_COMM'){
                const data = JSON.parse(fcmBase.data) as AppComm
                AppCommHandlerService.handleComm(data)
            }
        });

    }

    private updateFcmToken(value: string) {
        rootStore.mainStore.fcmToken = value
        LocalStorageService.updateStorage('fcm_token', value)
    }


}


export default new FCMService()